import { render, staticRenderFns } from "./BroadcastCard.vue?vue&type=template&id=5721bc5a&"
import script from "./BroadcastCard.vue?vue&type=script&lang=js&"
export * from "./BroadcastCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports